module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_base_pairs_dna_8-53f291adc0dd4623038d7427eab09706.jpg";